export class DafSefariaToggle {
  constructor() {
    this.shareWrapper = document.querySelector('.daf_sefaria-mobile');
    this.shareButton = this.shareWrapper ? this.shareWrapper.querySelector('#daf_sefaria__btn .wp-block-button__link') : null;
    this.closeButton = this.shareWrapper ? this.shareWrapper.querySelector('.daf_exit') : null;

    if (this.shareWrapper && this.shareButton) {
      this.init();
    }
  }

  init() {
    this.shareButton.addEventListener('click', () => {
      this.toggleActiveClass();
      this.updateButtonText();
    });

    this.closeButton.addEventListener('click', () => {
      this.toggleActiveClass();
    });
  }

  toggleActiveClass() {
    this.shareWrapper.classList.toggle('active');
  }

  updateButtonText() {
    if (this.shareWrapper.classList.contains('active')) {
      this.shareButton.textContent = 'Close Daf Text';
    } else {
      this.shareButton.textContent = 'Open Daf Text';
    }
  }
}